<template>
    <div class="section-set-password container">
        <ButtonCustom
            classBtn="section-set-password__button-back"
            type="go-back"
            :text="text"
            :isGoBackHistory="false"
            @onClickButton="onClickGoBack"
        />

        <FormCommon
            v-if="methodLogin === 1"
            :formItem="formItem"
            :dataForm="dataForm"
            @on-bur-input="onBurInputFormData"
            @update-form-data="updateFormData"
            @onSubmitForm="onSubmitForm"
            @onToggleShowPassword="onToggleShowPassword"
        >
            <div class="box-btn" slot="button">
                <div class="section-set-password__btn">
                    <ButtonCustom
                        classBtn="section-set-password__btn-close"
                        typeBtn="button"
                        type="default"
                        text="cancel"
                        @onClickButton="onClickCancel"
                    />
                    <ButtonCustom
                        classBtn="section-set-password__btn-continue"
                        typeBtn="submit"
                        type="primary"
                        :isLoading="isLoadingButton"
                        :text="textBtnContinue"
                        :icon="isShowIconBtnContibue ? 'arrow-right.png' : null"
                    />
                </div>
            </div>
        </FormCommon>
        <div v-if="methodLogin === 2">
            <p class="sent-email t-fir-transform-cap">
                {{
                    getTranslatedText(
                        "we have sent password reset link and instruction to your email"
                    )
                }}
            </p>
            <div class="email">
                <span>{{ dataUser.email}}</span>
                <button
                    class="btn-edit-email t-transform-cap"
                    @click="onClickGoBack"
                >
                    {{ getTranslatedText("edit") }}.
                </button>
            </div>

            <p class="email-description t-fir-transform-cap">
                {{
                    getTranslatedText(
                        "we have sent password reset link and instruction to your email"
                    )
                }}
            </p>
            <div class="btn-resend">
                <button
                    class="t-transform-cap"
                    :disabled="isDisableResend"
                    @click.prevent="handleResendLink"
                >
                    {{ getTranslatedText("resend link") }}
                </button>
                <span>in {{ renderNumber(timerCount) }} {{ getTranslatedText("min") }} </span>
            </div>
            <ButtonCustom
                classBtn="button-method-login"
                text="edit"
                typeBtn="button"
                type="primary"
                @onClickButton="onClickGoBack"
            />
        </div>
    </div>
</template>
<script>
import { isStrEmpty, renderLocaleNumber } from "@/components/common/utils";

import FormCommon from "@/components/common/form";
import ButtonCustom from "@/components/common/button";

import languageMixin from "@/mixins/language/language-mixin";

const LIMIT_PASSWORD = process.env.VUE_APP_LIMIT_PASSWORD;

export default {
    mixins: [languageMixin],
    components: {
        FormCommon,
        ButtonCustom,
    },
    props: {
        text: {
            type: String,
            default: "",
        },
        textBtnContinue: {
            type: String,
            default: "Continue",
        },
        isShowIconBtnContibue: {
            type: Boolean,
            default: true,
        },
        dataUser: {
            type: Object,
            default() {
                return {};
            },
        },
        isLogin: {
            type: Boolean,
            default: false,
        },
        methodLogin: {
            type: Number,
            default: 0,
        },
        isLoadingButton: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            timerCount: 60,
            isDisableResend: true,
            dataForm: {
                password: "",
                confirmPassword: "",
                isCheckPassWord: [],
            },
            formItem: [
                {
                    type: "input",
                    typeInput: "password",
                    typeShow: 'password',
                    placeholder: "",
                    name: "password",
                    required: true,
                    hideIconRq: true,
                    label: "enter password",
                    for: "input-password",
                    id: "input-password",
                    state: null,
                    textInvalid: "please enter the correct password",
                    textValid: "",
                },
                // {
                //     type: "checkBox",
                //     name: "isCheckPassWord",
                //     label: "password must contain:",
                //     id: "check-pass-word",
                //     plain: true,
                //     stacked: true,
                //     class: "validate-pass-word",
                //     options: [
                //         {
                //             text: this.getTranslatedText(
                //                 "at least 1 character"
                //             ),
                //             value: "1",
                //             disabled: true,
                //         },
                //         {
                //             text: this.getTranslatedText("at least 1 number"),
                //             value: "2",
                //             disabled: true,
                //         },
                //         {
                //             text: this.getTranslatedText(
                //                 "at least 1 special character"
                //             ),
                //             value: "3",
                //             disabled: true,
                //         },
                //         {
                //             text: this.getTranslatedText(
                //                 "at least 1 capital character"
                //             ),
                //             value: "4",
                //             disabled: true,
                //         },
                //         {
                //             text: this.getTranslatedText(
                //                 "at least [limit] characters", {
                //                     limit: LIMIT_PASSWORD,
                //                 }
                //             ),
                //             value: "5",
                //             disabled: true,
                //         },
                //     ],
                // },
                // {
                //     type: "input",
                //     typeInput: "password",
                //     typeShow: 'password',
                //     placeholder: "",
                //     name: "confirmPassword",
                //     required: true,
                //     hideIconRq: true,
                //     label: "confirm password",
                //     for: "input-confirmPassword",
                //     id: "input-confirmPassword",
                //     state: null,
                //     textInvalid: "passwords are not the same",
                //     textValid: "",
                // },
            ],
        };
    },
    watch: {
        timerCount: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.timerCount--;
                    }, 1000);
                }
                if (value === 0) {
                    this.isDisableResend = false;
                }
            },
            immediate: true,
        },
    },
    methods: {
        handleResendLink() {
            this.timerCount = 60;
            this.$emit("submitResend");
        },
        updateFormData(item) {
            let { value, name } = item;
            // if (name === "password") {
            //     let isContainsLowercase = /^(?=.*[a-z]).*$/;
            //     let isContainsNumber = /^(?=.*[0-9]).*$/;
            //     let isContainsSymbol =
            //         /^(?=.*[~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_₹]).*$/;
            //     let isContainsUppercase = /^(?=.*[A-Z]).*$/;

            //     // check at least 1 character
            //     if (
            //         isContainsLowercase.test(value) &&
            //         !this.dataForm.isCheckPassWord.includes("1")
            //     ) {
            //         this.dataForm.isCheckPassWord.push("1");
            //     }

            //     if (
            //         !isContainsLowercase.test(value) &&
            //         this.dataForm.isCheckPassWord.includes("1")
            //     ) {
            //         let indexCharacter =
            //             this.dataForm.isCheckPassWord.findIndex(
            //                 (x) => x === "1"
            //             );
            //         this.dataForm.isCheckPassWord.splice(indexCharacter, 1);
            //     }
            //     // check at least 1 number
            //     if (
            //         isContainsNumber.test(value) &&
            //         !this.dataForm.isCheckPassWord.includes("2")
            //     ) {
            //         this.dataForm.isCheckPassWord.push("2");
            //     }
            //     if (
            //         !isContainsNumber.test(value) &&
            //         this.dataForm.isCheckPassWord.includes("2")
            //     ) {
            //         let indexNumber = this.dataForm.isCheckPassWord.findIndex(
            //             (x) => x === "2"
            //         );
            //         this.dataForm.isCheckPassWord.splice(indexNumber, 1);
            //     }
            //     // check at least 1 Symbol
            //     if (
            //         isContainsSymbol.test(value) &&
            //         !this.dataForm.isCheckPassWord.includes("3")
            //     ) {
            //         this.dataForm.isCheckPassWord.push("3");
            //     }
            //     if (
            //         !isContainsSymbol.test(value) &&
            //         this.dataForm.isCheckPassWord.includes("3")
            //     ) {
            //         let indexSpecial = this.dataForm.isCheckPassWord.findIndex(
            //             (x) => x === "3"
            //         );
            //         this.dataForm.isCheckPassWord.splice(indexSpecial, 1);
            //     }
            //     // check at least 1 capital
            //     if (
            //         isContainsUppercase.test(value) &&
            //         !this.dataForm.isCheckPassWord.includes("4")
            //     ) {
            //         this.dataForm.isCheckPassWord.push("4");
            //     }
            //     if (
            //         !isContainsUppercase.test(value) &&
            //         this.dataForm.isCheckPassWord.includes("4")
            //     ) {
            //         let indexCapital = this.dataForm.isCheckPassWord.findIndex(
            //             (x) => x === "4"
            //         );
            //         this.dataForm.isCheckPassWord.splice(indexCapital, 1);
            //     }

            //     // check at least 8 Characters
            //     if (
            //         value.length >= LIMIT_PASSWORD &&
            //         !this.dataForm.isCheckPassWord.includes("5")
            //     ) {
            //         this.dataForm.isCheckPassWord.push("5");
            //     }
            //     if (
            //         value.length < LIMIT_PASSWORD  &&
            //         this.dataForm.isCheckPassWord.includes("5")
            //     ) {
            //         let indexLimitCharacter = this.dataForm.isCheckPassWord.findIndex(
            //             (x) => x === "5"
            //         );
            //         this.dataForm.isCheckPassWord.splice(indexLimitCharacter, 1);
            //     }

            //     if (!isStrEmpty(this.dataForm.confirmPassword)) {
            //         this.formItem[2].state = null;
            //         this.dataForm.confirmPassword = "";
            //     }

            //     if (
            //         this.dataForm.isCheckPassWord.length === 5 &&
            //         this.formItem[0].state !== null
            //     ) {
            //         this.formItem[0].state = true;
            //     }
            // }

            if (
                value.length >= LIMIT_PASSWORD &&
                this.formItem[0].state !== null
            ) {
                this.formItem[0].state = null;
            }

            this.dataForm[name] = value;
        },

        onBurInputFormData(event) {
            let { value, name } = event.target;
            if (value.length > 3) {
                let item = {
                    value,
                    name,
                };
                this.updateFormData(item);
            }

            // if (
            //     name === "confirmPassword" &&
            //     value === this.dataForm.password &&
            //     !this.formItem[2].state
            // ) {
            //     this.formItem[2].state = true;
            // }

            // if (
            //     name === "confirmPassword" &&
            //     value !== this.dataForm.password &&
            //     this.formItem[2].state !== null
            // ) {
            //     this.formItem[2].state = false;
            // }
        },

        onSubmitForm() {
            if (this.dataForm.password.length < LIMIT_PASSWORD) {
                this.formItem[0].state = false;
                this.formItem[0].textInvalid = this.getTranslatedText("at least [limit] characters", { limit: LIMIT_PASSWORD})
                return false;
            }

            // if (this.dataForm.password !== this.dataForm.confirmPassword) {
            //     this.formItem[2].state = false;
            //     return false;
            // }
            this.$emit("on-submit-password", this.dataForm);
        },

        onClickCancel() {
            this.$emit("onClickGoBack");
        },

        onClickGoBack() {
            this.$emit("onClickGoBack");
        },

        renderNumber(number) {
            return renderLocaleNumber(parseInt(number))
        },

        onToggleShowPassword(name) {
            let index = this.formItem.findIndex(x => x.name === name)
            if(index !== -1 ) {
                this.formItem[index].typeShow = this.formItem[index].typeShow === 'password' ? 'text' : 'password'
            }
        }

    },
};
</script>

<style
    scoped
    lang="scss"
    src="@/assets/scss/mobile/authenticate/_set-password.scss"
/>
